import AgendaNova from './AgendaNova';

export default AgendaNova;